import { render, staticRenderFns } from "./PageListByOther.vue?vue&type=template&id=0bab6413&scoped=true"
import script from "./PageListByOther.vue?vue&type=script&lang=ts"
export * from "./PageListByOther.vue?vue&type=script&lang=ts"
import style0 from "./PageListByOther.vue?vue&type=style&index=0&id=0bab6413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab6413",
  null
  
)

export default component.exports